import actions from "@/core/store/modules/layout/actions";
import getters from "@/core/store/modules/layout/getters";
import mutations from "@/core/store/modules/layout/mutations";
import config from "@/core/store/modules/layout/layout.config.json";


export default {
    state: {
        config: config,
        initial: config,
        classes: {}
    },
    getters,
    mutations,
    actions
}